import { IconsaxIcon } from "@/src/models/user.model";
import { useTheme } from "@/src/styles/theme-provider";
import * as Iconsax from "iconsax-react-nativejs";
import React, { memo } from "react";
import { Text, View } from "react-native";

type InfoRowProps = Readonly<{
  label: string;
  value: string | React.ReactNode;
  iconName?: keyof typeof Iconsax;
  isMultiLine?: boolean;
}>;

const InfoRow: React.FC<InfoRowProps> = ({
  label,
  value,
  iconName,
  isMultiLine = false,
}) => {
  const Icon = iconName ? (Iconsax[iconName] as IconsaxIcon) : null;
  const { themeVars } = useTheme();

  return (
    <View className="flex-row items-center gap-4">
      {Icon && (
        <Icon size={24} color={themeVars["--color-primary-default"] as string} />
      )}
      <View className="gap-1 flex-1">
        <Text className="text-slate">{label}</Text>
        {isMultiLine ? (
          <>
            <Text className="text-onyx">{value}</Text>
          </>
        ) : (
          <Text className="text-onyx">{value}</Text>
        )}
      </View>
    </View>
  );
};

export default memo(InfoRow);
